<template>
  <div class="directory">
    <div class="directory-list">
      <div v-for="reference of referencesList.slice(0,4)" :key="reference.id" class="guides-list-item">
        <div class="guides-list-item-head">
          <h3 class="guides-list-item-title" v-bind:class="{ active: displayBody == reference.id }" @click="openBody(reference.id)">{{reference.title}}</h3>
          <!--el-button v-if="displayBody == 0" size="small"  @click="openBody(reference.id)"><i class="el-icon-arrow-down"></i></el-button>
          <el-button v-if="displayBody == reference.id" size="small" @click="closeBody()"><i class="el-icon-arrow-up"></i></el-button-->
        </div>
        <div class="directory-references-list" v-if="displayBody == reference.id">
          <reference-item
            v-for="item of reference.items"
            :key="item.id"
            :reference-item="item"
            :active-edit-item-id="activeEditItemId"
            @onEditItem="editItemHandler"
            @onDeleteItem="deleteItemHandler"
            @onCancelEditItem="cancelEditItemHandler"
          />
        </div>
      </div>
    </div>

    <el-dialog title="Создание записи" :visible.sync="createDialogVisible">
      <div class="guides-modal">
        <div class="guides-modal-row">
          <label>
            <span>Название</span>
            <el-input v-model="newReferenceName" autocomplete="off"></el-input>
          </label>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button>Отмена</el-button>
        <el-button type="primary" @click="saveReferencesItem()">Сохранить</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  // components
  import ReferenceItem from "./ReferenceItem.vue"

  // api
  import { getFullReferencesApi, getReferenceAddItemApi, getReferenceRemoveItemApi } from "../../../../api/references";

  // vuex
  import { mapGetters } from "vuex";

  import { GET_USERS } from "../../../../store/actions/users";

  export default {
    name: 'Directory',
    data() {
      return {
        group: '',
        referencesList: [],
        currentReferenceId: null,
        createDialogVisible: false,
        newReferenceName: '',
        newReferenceKeyword: '',
        newReferenceKeywordList: [],
        activeEditItemId: null,
        roles: this.$t('user.roles'),
        newUsers: '',
        displayBody: 1,
      };
    },
    computed: {
      ...mapGetters([
        "users",
        "isAdmin",
      ]),
    fields () {
        if (!this.model) return []

        return Object.keys(this.model).map(key => {
          return {
            key,
            value: this.model[key] || 'n/a',
          }
        })
      },
    },
    methods: {
      getRole(role) {
        return this.roles.find(item => item.name === role).title;
      },
      loadReferences() {
          const params = {}
          getFullReferencesApi(params).then((resp) => {
            this.referencesList = resp.data;
          });
      },
      openBody(id) {
          this.displayBody = id
          console.log('id', this.displayBody)
      },
      closeBody() {
          this.displayBody = 0
      },
      addItemHandler(id) {
        this.currentReferenceId = id;
        this.createDialogVisible = true;
      },
      editItemHandler(id) {
        this.activeEditItemId = id;
      },
      cancelEditItemHandler() {
        this.activeEditItemId = null;
      },
      deleteItemHandler(id) {
        getReferenceRemoveItemApi({ item_id: id}).then(() => {
          this.loadReferences();
        })
      },
      saveReferencesItem() {
        if (!this.currentReferenceId && this.newReferenceName === '') {
          return
        }

        const params = {
          reference_id: this.currentReferenceId,
          keyword: this.newReferenceName,
          group_id: parseInt(this.group)
        }
        getReferenceAddItemApi(params).then(() => {
          this.currentReferenceId = null;
          this.newReferenceName = '';
          this.createDialogVisible = false;
          this.loadReferences();
        })
      }
    },
    
    mounted() {
      console.log('mounted');
      this.loadReferences()

      this.$store.dispatch(GET_USERS);

      },
    components: {
        ReferenceItem
      }
  };
</script>

<style>
  .guides-head {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  .directory-list {
    display: flex;
  }
  .guides-list-item:not(:last-child) {
    margin-bottom: 40px;
  }
  .guides-list-item-head {
    display: flex;
    align-items: center;
    margin: 20px 0 15px;
  }
  .guides-list-item-head .el-button--small, .el-button--small.is-round {
    padding: 4px 15px;
  }
  .guides-list-item-title {
    margin: 0 20px 0 0;
    padding: 10px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }
  .guides-list-item-title.active{
    background: #409EFF;
    color: white;
  }
  .directory-references-list {
    position: absolute;
    left: 100px;
    width: 80%;
  }
  .guides-references-list-item {}
  .guides-modal-row {}
  .guides-modal-row span {
    display: block;
    margin-bottom: 5px;
  }

  @media screen and (max-width: 480px) {
    .directory-references-list{
      left: 0;
      width: 100%;
    }
    .guides-references-item-head {
      display: block;
    }
    .white-space{
      white-space: break-spaces;
      margin-top: 5px;
    }
  }
</style>